<template>
  <div id="app">
    <router-view v-slot="{ Component, route }">
      <keep-alive>
        <component
          :is="Component"
          v-if="route.meta.isKeepAlive"
          :key="route.name"
        />
      </keep-alive>
      <component
        :is="Component"
        v-if="!route.meta.isKeepAlive"
        :key="route.name"
      />
    </router-view>
  </div>
</template>
<script>
if (
  window.location.protocol !== "https:" &&
  window.location.host.indexOf("localhost") < 0
) {
  window.location.href = window.location.href.replace("http:", "https:");
}
export default {
  created() {
    // 获取登录信息
    // this.$store.dispatch("user/getLoginInfo");
  },
};
</script>
<style lang="less">
</style>
<style lang="less">
@color: #ee2223;
</style>